<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ViewProvisionDetails')"
      width="700px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <div class="form-row" style="flex-direction:row;max-width: 920px">
          <el-form
            label-width="100px"
            label-position="left"
            style="margin-right:10px"
          >
            <cargo-ag-grid
              ref="jobsList"
              :show-side-bar="false"
              :grid-options="options"
              :column-defs="columnDefs"
              :row-data="jobs"
              style="width: 100%;min-width: 180px"
              @gridReady="params=>{gridApi=params.api}"
            />
          </el-form>
        </div>
      </div>
      <div class="spacing" />
      <div class="triggers" align="right">
        <el-button no="close" type="primary" @click="cancel">
          {{ $t('common.btn.close') }}
        </el-button>
      </div>
    </el-dialog>

    <!--    查看关联业务-->
    <show-job-dialog
      v-if="showJobDialog.visible"
      ref="showJobDialog"
      :visible.sync="showJobDialog.visible"
      :jobs="showJobDialog.jobs"
      @close="showJobDialog.visible = false"
    />
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage } from '@/utils/commonUtil'
import { queryJobDataByUuidsFunc } from '@/api/ruleConfig/provisionReport'
import $store from '@/store'
import ShowJobDialog from '@/views/cargo/v0/Performance/tabPane/showJobDialog.vue'

export default {
  name: 'ShowHistoryJobDialog',
  components: { ShowJobDialog, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    jobs: { type: Array, default: () => [] },
    ruleConfigs: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        columnApi: null
      },
      showJobDialog: {
        visible: false,
        jobs: []
      },
      dataRows: [],
      documentManage: new DocumentManage(),
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Message.Name2'),
          colId: 'userId',
          field: 'userId',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Post'),
          colId: 'commissionRole',
          field: 'commissionRole',
          width: 150,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(SystemConstants.COMMISSION_ROLE_LIST, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessVolume'),
          colId: 'businessNum',
          field: 'businessNum',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableRule'),
          colId: 'applicableScriptUuid',
          field: 'applicableScriptUuid',
          width: 150,
          cellRenderer: (params) => {
            if (this.ruleConfigs && this.ruleConfigs.length > 0 && params.data.applicableScriptUuid) {
              const ruleC = this.ruleConfigs.filter(p => p.uuid === params.data.applicableScriptUuid)
              if (ruleC && ruleC.length > 0) {
                return ruleC[0].scriptName
              }
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionAmount'),
          colId: 'commissionAmount',
          field: 'commissionAmount',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ViewDetailedBusiness'),
          field: 'dateCreated',
          width: 200,
          editable: () => false,
          cellRenderer: params => {
            if (params.data.businessNum) {
              const onViewDetailedBusiness = this.documentManage.getPath('onViewDetailedBusiness')
              return `<button type="button"><div onclick="${onViewDetailedBusiness}('${params.data.jobs}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div></button>`
            } else {
              return ''
            }
          }
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {
    const context = this
    this.documentManage.set('onViewDetailedBusiness', function(value) {
      context.onViewDetailedBusiness(value)
    })
  },
  mounted() {
  },
  methods: {
    onViewDetailedBusiness(jobs) {
      if (jobs && jobs.length !== 0) {
        const uuids = jobs.split(',')
        queryJobDataByUuidsFunc({ branchId: $store.getters.currentOfficeId, keys: uuids }).then(res => {
          this.showJobDialog.jobs = res.data
          this.showJobDialog.visible = true
        })
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style scoped>

.spacing {
  padding-top: 20px;
}
</style>

